import { useSelector } from "react-redux";

import {
  selectPrimaryInsuranceCarrier,
  selectSelfAcpConsentResponse,
} from "@/redux/selectors/patientSelectors";

import type { ACPStatus } from "../types";
import { getACPStatus } from "../helpers/program-status";

export function useACPStatus(): ACPStatus {
  const consentResponse = useSelector(selectSelfAcpConsentResponse);
  const insuranceCarrier = useSelector(selectPrimaryInsuranceCarrier);

  return getACPStatus({
    consentResponse,
    insuranceCarrier,
  });
}
